import HttpCliente from "../HttpCliente";

export const getMiBandejaPaginada = (token, page, pageSize, filtros) => {
  const params = new URLSearchParams({
    pageNumber: page,
    pageSize: pageSize,
  });
  if (filtros?.searchTerm) params.append("nombre", filtros.searchTerm);
  if (filtros?.regulador) params.append("regulador", filtros.regulador);
  if (filtros?.tipoDocumento) params.append("tipoDocumento", filtros.tipoDocumento);
  if (filtros?.rubro) params.append("rubro", filtros.rubro);
  if (filtros?.pais) params.append("pais", filtros.pais);
 
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/BandejaSuscriptor/MiBandeja?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};